// @flow

import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withJob } from 'react-jobs';
import styled from 'styled-components';
import Link from 'react-router-dom/Link';
import Helmet from 'react-helmet';

import type { Article } from '../../types/model';

import { selectors, requestArticle } from '../../redux/modules/articles';
import { getCategoryColor } from '../../utils';

import { Loading } from '../StyledComponents';
import ArticleContent from './ArticleContent';

const Root = styled.div`
  position: relative;

  display: flex;
  min-height: 420px;
  max-height: 510px;

  background-color: #3C3C3C;
`;

const Header = styled.header`
  margin-bottom: 15px;
`;

const ContentWrap = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;
  margin: 15px 60px 15px 90px;
  padding-right: 30px;

  overflow: auto;

  color: #FCFCFC;
`;

const ArticleTitle = styled.h1`
  margin: 0;

  text-transform: uppercase;

  font-weight: normal;
  line-height: 1.2;

  color: ${props => props.color ? props.color : '#FCFCFC'};
`;

const ArticleInfo = styled.div`
  flex: 1;
  display: flex;
`;

const Content = styled.div`
  flex: 1;
`;

const CloseButton = styled(Link)`
  position: absolute;
  left: 30px;
  top: 15px;
  transform: translateX(-50%);

  border: none;

  text-decoration: none;

  font-size: 36px;
  font-weight: 300;

  background: transparent;
  color: ${props => props.color ? props.color : '#FCFCFC'};

  cursor: pointer;
  outline: none;
`

const StyledLoading = styled(Loading)`
  background-color: #fff;
`;

type Props = {
  color: ?string,
  article: Article,
}

function ArticleDrawer({ color, article }: Props) {
  return (
    <Root>
      <Helmet>
        <title>{article.title}</title>
      </Helmet>

      <ContentWrap>

        <Header>
          <ArticleTitle color={color}>
            {article.title}
          </ArticleTitle>
        </Header>

        <ArticleInfo>
          <Content>
            <ArticleContent body={article.body} />
          </Content>
        </ArticleInfo>

      </ContentWrap>

      <CloseButton
        color={color}
        to={`/patient/${article.categoryId}`}
      >
        ✕
      </CloseButton>
    </Root>
  );
}

function mapStateToProps(state, props) {
  const articleId = parseInt(props.match.params.id, 10);
  const article = selectors.getById(state.articles, articleId);

  return ({
    articleId,
    article,
    color: getCategoryColor(articleId),
  });
}

const mapActionsToProps = {
  requestArticle,
}

export default compose(
  connect(mapStateToProps, mapActionsToProps),
  withJob({
    work: props => props.requestArticle(props.articleId),
    LoadingComponent: () => <Root><StyledLoading /></Root>,
  })
)(ArticleDrawer);



// WEBPACK FOOTER //
// ./src/components/ArticleDrawer/ArticleDrawer.js